import Constants from '../actions/types';

const initialState = {
  links: [],
  loading: false,
  message: null,
  severity: null
};

const recordLinksReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.RECORD_LINKS_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.RECORD_LINKS_GET_SUCCESS: {
      const links = action.payload;
      const newState = {
        links: links,
        loading: false,
        message: null,
        severity: null
      };

      return newState;
    }

    case Constants.RECORD_LINKS_GET_FAILURE: {
      const newState = {
        links: [],
        loading: false
      };

      return newState;
    }

    case Constants.RECORD_LINKS_CLASSIFYMATCH_SUCCESS: {
      const found = state.links.find(
        link => (link.recordLinkId = action.payload.recordLinkId)
      );
      const index = state.links.indexOf(found);
      const newState = {
        ...state,
        links: [
          ...state.links.slice(0, index),
          ...state.links.slice(index + 1)
        ],
        loading: false,
        message: 'Classified pair successfully as a match.',
        severity: 'info'
      };

      return newState;
    }

    case Constants.RECORD_LINKS_CLASSIFYMATCH_FAILURE: {
      const newState = {
        ...state,
        loading: false,
        message: action.payload,
        severity: 'error'
      };

      return newState;
    }

    case Constants.RECORD_LINKS_CLASSIFYNMATCH_SUCCESS: {
      const found = state.links.find(
        link => (link.recordLinkId = action.payload.recordLinkId)
      );
      const index = state.links.indexOf(found);
      const newState = {
        ...state,
        links: [
          ...state.links.slice(0, index),
          ...state.links.slice(index + 1)
        ],
        loading: false,
        message: 'Classified pair successfully as a non-match.',
        severity: 'info'
      };

      return newState;
    }

    case Constants.RECORD_LINKS_CLASSIFYNMATCH_FAILURE: {
      const newState = {
        ...state,
        loading: false,
        message: action.payload,
        severity: 'error'
      };

      return newState;
    }

    case Constants.RECORD_LINKS_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default recordLinksReducer;
